import moment from 'moment';
import 'moment/locale/ru';

moment.locale('ru');

export class Utils {
  /**
	 * Функция создает момент из метки времени Unix и возращает в виде строки в заданном формате
	 * @param {Number} date
	 * @param {String} format
	 * @return {String}
	 * getFormattedDate(1653917508, "DD.MM.YYYY");
	 * 30.05.2022
	 * подробнее о форматах https://momentjs.com/docs/#/displaying/format/
	 */
  getFormattedDate(date, format = 'DD.MM.YYYY HH:mm') {
    if (!date) return '';
    return moment.unix(date).format(format);
  }

  /**
	 * Функция подствляет правильное окончание слова в зависимости от числа
	 * @param {Number} n
	 * @param {Array} forms
	 * @return {String}
	 * wordEnding(42, ["арбуз", "арбуза", "арбузов"]);
	 * 42 арбуза
	 */
  wordEnding(n, forms) {
    n = Math.abs(n) % 100;
    const n1 = n % 10;
    if (n > 10 && n < 20) {
      return forms[2];
    }
    if (n1 > 1 && n1 < 5) {
      return forms[1];
    }
    if (n1 === 1) {
      return forms[0];
    }
    return forms[2];
  }

  /**
	 * Функция создает из строки момент времени Unix
	 * @param {String} dateString
	 * @return {Number}
	 * getUnixTimestamp('YYYY-MM-DD HH:mm:ss');
	 */
  getUnixTimestamp(dateString) {
    if (!dateString?.trim()) return 0;

    const date = moment(dateString.trim(), 'YYYY-MM-DD HH:mm:ss', true);
    return date.isValid() ? date.unix() : 0;
  }

  formatNumber(num) {
    return num >= 10000 ? num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ' ') : num.toString();
  }
}

export const utils = new Utils();
